import { AppConfigBottomBarItem } from '../components/scenes/app-menu/types'; // TODO Fix this
import type { FotbollPlayAppConfig } from '../components/scenes/fotbollplay/api/types';
import { PROMO_VARIANT } from './team';

export enum SUPPORTED_LEAGUES {
  ALLSVENSKAN = 'allsvenskan',
  DAMALLSVENSKAN = 'damallsvenskan',
  SUPERETTAN = 'superettan',
  FUTSAL = 'futsal',
  OBOS = 'obos',
  ELITESERIEN = 'eliteserien',
  ELITETTAN = 'elitettan',
  NONE = '',
}

export enum DEVICES {
  MOBILE = 'mobile',
  TABLET = 'tablet',
}

export enum APP_TYPE {
  CLUB = 'club',
  LEAGUE = 'league',
}

export type ConfigLeagueNameOptions =
  | SUPPORTED_LEAGUES.ALLSVENSKAN
  | SUPPORTED_LEAGUES.DAMALLSVENSKAN
  | SUPPORTED_LEAGUES.SUPERETTAN
  | SUPPORTED_LEAGUES.FUTSAL
  | SUPPORTED_LEAGUES.OBOS
  | SUPPORTED_LEAGUES.SUPERETTAN
  | SUPPORTED_LEAGUES.ELITETTAN
  | SUPPORTED_LEAGUES.NONE;

export interface Lottery {
  arena_coordinates: string;
  arena_gps_radius: string;
  enabled: string;
}

export interface LeagueSponsor {
  color: string;
  image: string | boolean;
  targeturl: string;
}

export type PaletteColors = {
  ID_MAIN: string;
  ID_FOREGROUND: string;
  ID_CONTRAST: string;
  COMPONENT_BACKGROUND: string;
  COMPONENT_FOREGROUND: string;
  COMPONENT_BORDER: string;
  COMPONENT_FOREGROUND_ID: string;
  BUTTON_BACKGROUND: string;
  BUTTON_FOREGROUND: string;
  TOP_BAR_BACKGROUND: string;
  TOP_BAR_FOREGROUND: string;
  TOP_BAR_CONTRAST: string;
  SOCIAL_HEART: string;
};

export interface AppThemeV2 {
  isLight: boolean;
  topBarOverride: boolean;
  palette: PaletteColors;
}

export interface Promo {
  height: number;
  promo_type: PROMO_VARIANT;
  width: number;
  contentUrl: string;
  targetUrl: string;
  promo_open_inapp: boolean;
  promo_age_restriction: boolean;
  timed: boolean;
  timedDateTime: string;
}

export interface Arena {
  name?: string;
  spectators?: string;
  built?: string;
  record?: string;
}

export type AppConfigFeatureFlagsComment = {
  disableComments?: boolean;
  disableCommentsNews?: boolean;
  disableCommentsStories?: boolean;
  disableCommentsArticles?: boolean;
};

export type AppConfigFeatureFlagsReactions = {
  disableReactions?: boolean;
  disableReactionsNews?: boolean;
  disableReactionsStories?: boolean;
  disableReactionsArticles?: boolean;
};

export type AppConfigFeatureFlags = AppConfigFeatureFlagsComment & AppConfigFeatureFlagsReactions;

export type AppConfigBottomBar = {
  items: AppConfigBottomBarItem[];
};

export type AppConfigSupport = {
  ticketEmail?: string;
  infoEmail?: string;
  appEmail?: string;
  phoneNumber?: string;
};

export type AppConfigData = {
  author?: string;
  hash: string;
  appKey?: string;
  appType: APP_TYPE;
  configLeagueName: ConfigLeagueNameOptions;
  appShortname: string;
  currentSeason: number | string;
  hasClubstreams: boolean;
  videoPlayerClubPartner: string;
  videoPlayerLeaguePartner: string;
  support?: AppConfigSupport;
  appThemeV2: AppThemeV2;
  appPromoImg: string;
  disableLiveVideo: boolean;
  lottery: Lottery | null;
  appPromoText: string;
  itunesUrl: string;
  leagueSponsor: LeagueSponsor | null;
  gplayUrl: string;
  gAKey: string;
  name: string;
  promos: Promo[];
  arena: Arena | null;
  featureFlags?: AppConfigFeatureFlags;
  bottomBar: AppConfigBottomBar;
  fotbollplay?: FotbollPlayAppConfig;
};

export enum LEAGUE_SEASON_OPTIONS {
  PREV_YEAR = new Date().getFullYear() - 1,
  CURRENT_YEAR = new Date().getFullYear(),
  NEXT_YEAR = new Date().getFullYear() + 1,
}

export enum LEAGUE_SEASON_OPTION {
  NONE = '',
}

type LeagueSeasonOptionTypeKeys = keyof typeof LEAGUE_SEASON_OPTIONS;
export type LeagueSeasonOptionTypes = {
  [key in LeagueSeasonOptionTypeKeys]: LEAGUE_SEASON_OPTIONS;
} & {
  ['NONE']: LEAGUE_SEASON_OPTION;
};
